import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";
import services from "../../services/services";
import Hiring from "../Jobs/Hiring";
import MetaTags from 'react-meta-tags';

const AIJobSummary = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const jobId = queryParams.get('jobId');
    const pagenum = queryParams.get('page');
    const explorepagenum = queryParams.get('ejpage');
    
    const [jobDetails, setJobDetails] = useState([]);
    const [companyDetails, setCompanyDetails] = useState([]);
    const [perksListInfo, setPerksListInfo] = useState([]);
    const [educations, setEducation] = useState([]);
    const [educationAr, setEducationAr] = useState([]);

    const [aiJobData, setAiJobData] = useState(null);

    const [matchingPoints, setMatchingPoints] = useState([]); // New state for API results
    const [isAiLoading, setIsAiLoading] = useState(false);

    const companyIdChkLogin = localStorage.getItem("logCompanyId");
    const studentIdChkLogin = localStorage.getItem("logStudentId");
    const jobSeekerIdChkLogin = localStorage.getItem("logProfileId");
    const userIdChkLogin = localStorage.getItem("logUserId");
    const chKRoleAr = localStorage.getItem("roleAr");

    const [summary, setSummary] = useState('');
    const [url, setUrl] = useState('');
    const [jobShareURL, setJobShareURL] = useState('');
    const [title, setTitle] = useState('');
    const staticData = require('../../constants/' + process.env.React_App_Static_Folder + '/static-data.json');

    useEffect(() => {
        window.scrollTo(0, 0);
        getEducation();
        getJobDetailsById();

        if (jobId) {
            const storedAiData = localStorage.getItem(`ai_job_${jobId}`);
            if (storedAiData) {
                try {
                    setAiJobData(JSON.parse(storedAiData));
                    const parsedData = JSON.parse(storedAiData);
                    fetchMatchingPoints(parsedData);
                } catch (err) {
                    console.error("Failed to parse AI data", err);
                }
            }
        }

        var siteurlval = document.URL;
        var spliturl = siteurlval.split(/[#]/);
        setUrl(spliturl[0]);
    }, [jobId]);

        const fetchMatchingPoints = async (itemData) => {
        setIsAiLoading(true);
        try {
             const baseurl = process.env.React_App_AWS_API;
            const response = await fetch(`${baseurl}analysis/matching-points`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "query": itemData.search_text_query || "", // Use the stored query
                    "item_type": "job",
                    "item_data": itemData, // Passing the complete object
                    "full_text": itemData.search_text_query || ""
                })
            });
            const resData = await response.json();
            if (resData.success) {
                setMatchingPoints(resData.matching_points);
            }
        } catch (error) {
            console.error("Error fetching matching points:", error);
        } finally {
            setIsAiLoading(false);
        }
    };

    const getEducation = () => {
        services.getEducation().then((res) => {
            setEducation(res.data.content);
            var dc = res.data.content;
            let tempAr = [];
            for (var i = 0; i < dc.length; i++) {
                var tempId = dc[i].educationId;
                var tempName = dc[i].name;
                tempAr[tempId] = tempName;
            }
            setEducationAr(tempAr);
        });
    }

    function getEduInfo(ed) {
        if (!ed || ed === "") {
            return "";
        }
        return educationAr[ed];
    }

    function getJobDetailsById() {
        services.getJobDetailsById(jobId).then((res) => {
            if (res.data) {
                setJobDetails(res.data.jobPostVo);
                var jobdata = res.data.jobPostVo;
                setTitle(jobdata.title);
                setSummary(jobdata.summary);
                setCompanyDetails(res.data.companyVo);
                var url_temp = process.env.React_App_FRONT_URL + "jobsummary?jobId=" + jobdata.jobId + "&title=" + jobdata.title;
                var encodeUrl = encodeURIComponent(url_temp);
                setJobShareURL(encodeUrl);

                if (res.data.companyVo.perksList) {
                    setPerksListInfo(res.data.companyVo.perksList);
                }
            }
        });
    }

    return (
        <>
            <MetaTags>
                <meta property="og:locale" content="en_US" />
                <meta name="title" id="main_title" content={title} />
                <meta name="description" id="main_description" content={summary} />
                <meta property="og:type" content="website" />
                <meta property="og:url" id="og_url" content={jobShareURL} />
                <meta property="og:title" id="og_title" content={title} />
                <meta property="og:description" id="og_description" content={summary} />
                <meta property="twitter:card" content="summary" />
                <meta name="twitter:site" content="@hometownopportunity" />
                <meta property="twitter:url" id="tw_url" content={jobShareURL} />
                <meta property="twitter:title" id="tw_title" content={title} />
                <meta property="twitter:description" id="tw_description" content={summary} />
            </MetaTags>
            <main className="empr-directory-main">
                <div className="main-bgpatten"></div>

                <section className="headtitle-wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <nav style={{ "--bs-breadcrumb-divider": "'>';" }} aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        {(() => {
                                            if (jobSeekerIdChkLogin != null && jobSeekerIdChkLogin != "null") {
                                                return (<li className="breadcrumb-item headtitle"> <a href="/profileDashboard">Job Seeker Dashboard</a> </li>);
                                            }
                                            if (studentIdChkLogin != null && studentIdChkLogin != "null") {
                                                return (<li className="breadcrumb-item headtitle"> <a href="/studentDashboard">Student Dashboard</a> </li>);
                                            }
                                            if (chKRoleAr == "schoolsuper") {
                                                return (<li className="breadcrumb-item headtitle"> <a href="/schoolAdminDashboard">School Admin</a> </li>);
                                            }
                                        })()}
                                        <li className="breadcrumb-item headtitle ">
                                            <a href="#">View Job - {jobDetails.title ? jobDetails.title.substring(0, 50) : ""}
                                                {jobDetails.title && jobDetails.title.length > 50 ? "..." : ""}
                                            </a>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="info-typography py-5">
                    <div className="container">
                        <div className="row pb-3">
                            <div className="d-flex">
                                <span className="mr-1 rotate-90">
                                    <img src="images/mob-arrow.png" alt="" />
                                </span>
                                {(() => {
                                    if (pagenum != null && pagenum != "null" && pagenum != "") {
                                        return (<Link to={"/availableJobs?return=true&page=" + pagenum} style={{ color: "#fff" }}>Back to Jobs List</Link>);
                                    } else if (explorepagenum != null && explorepagenum != "null" && explorepagenum != "") {
                                        return (<Link to={"/careerExploreJobs?return=true&pageid=" + explorepagenum} style={{ color: "#fff" }}>Back to Jobs List</Link>);
                                    } else {
                                        return (<Link to={"/availableJobs?return=true"} style={{ color: "#fff" }}>Back to Jobs List</Link>);
                                    }
                                })()}
                            </div>
                        </div>

                        <div className="row">
                            {/* --- DESKTOP VIEW --- */}
                            <div className="col-lg-8">
                                <div className="py-5 px-5 white-bg position-relative cd-desktop" style={{ paddingBottom: "20px" }}>
                                    <div className="row jobsummary-content">
                                        <div className="company-summery">
                                            <div className="mb-4 d-flex cs-tab">
                                                <img src={companyDetails.logoUrl ? companyDetails.logoUrl : staticData.default_logo} alt="" className="mr-2" />
                                                <div>
                                                    <p className="mb-0"><a href={`/companyDetails?companyId=` + companyDetails.companyId + `&page=` + pagenum}>{companyDetails.name}</a> </p>
                                                    <p className="mb-0">{companyDetails.address1 != '' ? companyDetails.address1 : ''}</p>
                                                    <p className="mb-0">
                                                        {companyDetails.city != '' ? companyDetails.city : ''}
                                                        {companyDetails.city != '' && companyDetails.state != '' ? ', ' : ''}
                                                        {companyDetails.state != '' ? companyDetails.state : ''}
                                                        {companyDetails.state != '' && companyDetails.zip != '' ? ', ' : ''}
                                                        {companyDetails.zip != '' ? companyDetails.zip : ''}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="right-info">
                                                <h4>{jobDetails.title}</h4>
                                            </div>

                                            <div className="stock-wrap ">
                                                {(jobDetails.jobApplyUrl == '' || jobDetails.jobApplyUrl == null) ? <a className="reg-button d-block" href={"/applyJobProfile?jobId=" + jobDetails.jobId}>Apply Now</a> : <a href={jobDetails.jobApplyUrl} target="_blank" rel="noreferrer" className="reg-button d-block">Apply Now</a>}
                                            </div>

                                            {/* <div className="d-flex">
                                                <span className="posted mx-0">{moment(jobDetails.createdDate).format("MM/DD/YYYY")}</span>
                                            </div> */}


                                            <div class="date">
                                                <b class="d-flex text-uppercase">
                                                    <span>{moment(jobDetails.createdDate).format("MM/DD/YYYY")}</span>
                                                </b>
                                            </div>
                                            
                                            <div className="d-flex align-items-center mt-4">
                                                <span className="text-uppercase">Share: </span>
                                                <div className="mx-2 cs-social">
                                                    <a id="fbsharebtn" target="_blank" rel="noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${jobShareURL}&src=sdkpreparse`}>
                                                        <img src="images/FACEBOOK 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a> &nbsp;
                                                    <a className="popup" target="_blank" rel="noreferrer" href={`https://www.linkedin.com/shareArticle?mini=true&url=${jobShareURL}`}>
                                                        <img src="images/LINKEDIN 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a> &nbsp;
                                                    <a className="popup" target="_blank" rel="noreferrer" href={`https://twitter.com/intent/tweet?text=${title}&url=${jobShareURL}`}>
                                                        <img src="images/TWITTER 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a> &nbsp;
                                                    <a target="_blank" rel="noreferrer" href={`mailto:?subject=Job:%20${title}&body=${jobShareURL}`}>
                                                        <img src="images/EMAIL 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="my-4" />

                                        {/* --- DYNAMIC AI INSIGHTS CARD (DESKTOP) --- */}
                                        {aiJobData && (
                                            <div className="ai-card mb-4">
                                                <div className="ai-header">
                                                    <div className="ai-title">
                                                        <span className="ai-icon">
                                                            <img src="/images/icon-golf.PNG" alt="icon" />
                                                        </span>
                                                        <h2>AI Matching Score:</h2>
                                                    </div>
                                                    <div className="ai-badge">
                                                        {aiJobData.score_percent ? Math.round(aiJobData.score_percent) : (aiJobData.score ? Math.round(aiJobData.score) : 0)}% Match
                                                    </div>
                                                </div>

                                                <h3 className="summary-title">
                                                    Profile Matching Summary and Observations:
                                                </h3>

                                                {/* <ul className="ai-list">
                                                    {aiJobData.debug && aiJobData.debug.explanation ? (
                                                        aiJobData.debug.explanation
                                                            .split('. ')
                                                            .filter((sentence) => sentence.trim().length > 0)
                                                            .map((sentence, index) => (
                                                                <li key={index}>
                                                                    {sentence.trim()}{sentence.endsWith('.') ? '' : '.'}
                                                                </li>
                                                            ))
                                                    ) : (
                                                        <li>Highly relevant match based on your search criteria.</li>
                                                    )}
                                                </ul> */}

                                                 <ul className="ai-list">
                                                    {isAiLoading ? (
                                                        <li>Analyzing profile match...</li>
                                                    ) : matchingPoints && matchingPoints.length > 0 ? (
                                                        matchingPoints.map((point, index) => (
                                                            <li key={index}>{point}</li>
                                                        ))
                                                    ) : (
                                                        <li>Highly relevant match based on your search criteria.</li>
                                                    )}
                                                </ul>


                                                {/* --- DESIGNER'S BASIC INFORMATION BLOCK (DESKTOP) --- */}
                                                <div className="st-emotion-cache-6c7yup e13xr0422 mt-4 pt-3 border-top">
                                                    <div data-testid="stMarkdownContainer" className="st-emotion-cache-1frkdi4 e1t8ru6f0">
                                                        <div data-testid="stHeadingWithActionElements" className="st-emotion-cache-1oqmf0p e1t8ru6f2">
                                                            <h5 id="basic-information" aria-labelledby=":r8:">
                                                                <span id=":r8:"> Basic Information</span>
                                                                
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="row px-2 mt-3">
                                                        {aiJobData.yearsOfExperience !== undefined && aiJobData.yearsOfExperience !== null && (
                                                            <div className="col-md-6 mb-2">
                                                                <strong style={{color: '#555', fontSize: '14px'}}>Experience Required:</strong> <span style={{textTransform: 'capitalize', fontSize: '14px'}}>{aiJobData.yearsOfExperience} Years</span>
                                                            </div>
                                                        )}
                                                        {aiJobData.locationScope && (
                                                            <div className="col-md-6 mb-2">
                                                                <strong style={{color: '#555', fontSize: '14px'}}>Work Setting:</strong> <span style={{textTransform: 'capitalize', fontSize: '14px'}}>{aiJobData.locationScope}</span>
                                                            </div>
                                                        )}
                                                        {aiJobData.employmentType && (
                                                            <div className="col-md-6 mb-2">
                                                                <strong style={{color: '#555', fontSize: '14px'}}>Employment:</strong> <span style={{textTransform: 'capitalize', fontSize: '14px'}}>{aiJobData.employmentType}</span>
                                                            </div>
                                                        )}
                                                        {aiJobData.location_city && aiJobData.location_state && (
                                                            <div className="col-md-6 mb-2">
                                                                <strong style={{color: '#555', fontSize: '14px'}}>Location:</strong> <span style={{textTransform: 'capitalize', fontSize: '14px'}}>{aiJobData.location_city}, {aiJobData.location_state_abbr ? aiJobData.location_state_abbr.toUpperCase() : aiJobData.location_state}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="mb-4 mt-2">
                                            <h4>JOB TYPE</h4>
                                            <p>{jobDetails.strJobType} </p>
                                        </div>

                                        <div className="mb-4">
                                            <h4>JOB SUMMARY</h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.summary }} />
                                            
                                            {/* --- DYNAMIC SKILLS --- */}
                                            {aiJobData && aiJobData.skills && aiJobData.skills.length > 0 && (
                                                <>
                                                    <p className="mt-4" style={{fontWeight: 'bold'}}>Key Skills</p>
                                                    <div className="skills mx-0 px-0">
                                                        {aiJobData.skills.map((skill, index) => (
                                                            <span key={index} className="skill" style={{textTransform: "capitalize", display: "inline-block", marginRight: "8px", marginBottom: "8px"}}>{skill}</span>
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="mb-4">
                                            <h4>CAREER LEVEL </h4>
                                            <p>{jobDetails.career} </p>
                                        </div>

                                        <div className="mb-4">
                                            <h4>EDUCATION LEVEL</h4>
                                            <p>{getEduInfo(jobDetails.educationId)}</p>
                                        </div>

                                        <div className="mb-4">
                                            <h4>EXPERIENCE/CERTIFICATION REQUIRED:</h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.experiance }} />
                                        </div>

                                        <div className="mb-4">
                                            <h4>SALARY/BENEFITS</h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.salary }} />
                                        </div>

                                        <div className="mb-4">
                                            <h4>ADDITIONAL INSTRUCTIONS TO APPLY:</h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.apply }} />
                                            <div style={{ marginTop: "25px" }}>
                                                {(jobDetails.jobApplyUrl == '' || jobDetails.jobApplyUrl == null) ? <a href={"/applyJobProfile?jobId=" + jobDetails.jobId} className="reg-button">Apply Now</a> : <a href={jobDetails.jobApplyUrl} target="_blank" rel="noreferrer" className="reg-button">Apply Now</a>}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* --- MOBILE VIEW --- */}
                                <div className="cd-mobile py-5 px-2 white-bg position-relative ">
                                    <div className="card border-0 border-bottom p-3 ">
                                        <div className="text-center">
                                            <img width="100%" src={companyDetails.logoUrl ? companyDetails.logoUrl : staticData.default_logo} alt="" />
                                        </div>
                                        <div className="text-left js-img">
                                            <hr className="my-4" />
                                            <div className="date">
                                                <b className="d-flex text-uppercase">
                                                    <span>{moment(jobDetails.createdDate).format("MM/DD/YYYY")}</span>
                                                </b>
                                            </div>

                                            <div className="mb-3">
                                                <p className="mb-0"><a href={`/companyDetails?companyId=` + companyDetails.companyId + `&page=` + pagenum}>{companyDetails.name}</a> </p>
                                                <p className="mb-0">{companyDetails.address1 != '' ? companyDetails.address1 : ''}</p>
                                                <p className="mb-0">
                                                    {companyDetails.city != '' ? companyDetails.city : ''}
                                                    {companyDetails.city != '' && companyDetails.state != '' ? ', ' : ''}
                                                    {companyDetails.state != '' ? companyDetails.state : ''}
                                                    {companyDetails.state != '' && companyDetails.zip != '' ? ', ' : ''}
                                                    {companyDetails.zip != '' ? companyDetails.zip : ''}
                                                </p>
                                            </div>
                                            <h4>{jobDetails.title}</h4>

                                            <div className="d-flex align-items-center my-4">
                                                <span className="text-uppercase">Share</span>
                                                <div className="mx-3">
                                                    <a id="fbsharebtn" target="_blank" rel="noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${jobShareURL}&src=sdkpreparse`}>
                                                        <img src="images/FACEBOOK 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a> &nbsp;
                                                    <a className="popup" target="_blank" rel="noreferrer" href={`https://www.linkedin.com/shareArticle?mini=true&url=${jobShareURL}`}>
                                                        <img src="images/LINKEDIN 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a> &nbsp;
                                                    <a className="popup" target="_blank" rel="noreferrer" href={`https://twitter.com/intent/tweet?text=${title}&url=${jobShareURL}`}>
                                                        <img src="images/TWITTER 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a> &nbsp;
                                                    <a target="_blank" rel="noreferrer" href={`mailto:?subject=Job:%20${title}&body=${jobShareURL}`}>
                                                        <img src="images/EMAIL 2.png" style={{ maxWidth: "32px" }} alt="" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="my-4" />

                                        {/* --- DYNAMIC AI INSIGHTS CARD (MOBILE) --- */}
                                        {aiJobData && (
                                            <div className="ai-card mb-4">
                                                <div className="ai-header">
                                                    <div className="ai-title">
                                                        <span className="ai-icon">
                                                            <img src="/images/icon-golf.PNG" alt="icon" />
                                                        </span>
                                                        <h2>AI Matching Score:</h2>
                                                    </div>
                                                    <div className="ai-badge">
                                                        {aiJobData.score_percent ? Math.round(aiJobData.score_percent) : (aiJobData.score ? Math.round(aiJobData.score) : 0)}% Match
                                                    </div>
                                                </div>

                                                <h3 className="summary-title">
                                                    Profile Matching Summary and Observations:
                                                </h3>

                                                {/* <ul className="ai-list">
                                                    {aiJobData.debug && aiJobData.debug.explanation ? (
                                                        aiJobData.debug.explanation
                                                            .split('. ')
                                                            .filter((sentence) => sentence.trim().length > 0)
                                                            .map((sentence, index) => (
                                                                <li key={index}>
                                                                    {sentence.trim()}{sentence.endsWith('.') ? '' : '.'}
                                                                </li>
                                                            ))
                                                    ) : (
                                                        <li>Highly relevant match based on your search criteria.</li>
                                                    )}
                                                </ul> */}

                                                <ul className="ai-list">
                                                    {isAiLoading ? (
                                                        <li>Analyzing profile match...</li>
                                                    ) : matchingPoints && matchingPoints.length > 0 ? (
                                                        matchingPoints.map((point, index) => (
                                                            <li key={index}>{point}</li>
                                                        ))
                                                    ) : (
                                                        <li>Highly relevant match based on your search criteria.</li>
                                                    )}
                                                </ul>

                                                {/* --- DESIGNER'S BASIC INFORMATION BLOCK (MOBILE) --- */}
                                                <div className="st-emotion-cache-6c7yup e13xr0422 mt-4 pt-3 border-top">
                                                    <div data-testid="stMarkdownContainer" className="st-emotion-cache-1frkdi4 e1t8ru6f0">
                                                        <div data-testid="stHeadingWithActionElements" className="st-emotion-cache-1oqmf0p e1t8ru6f2">
                                                            <h5 id="basic-information" aria-labelledby=":r8:">
                                                                <span > Basic Information</span>
                                                               
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="row px-2 mt-3">
                                                        {aiJobData.yearsOfExperience !== undefined && aiJobData.yearsOfExperience !== null && (
                                                            <div className="col-12 mb-2">
                                                                <strong style={{color: '#555', fontSize: '13px'}}>Experience Required:</strong> <span style={{textTransform: 'capitalize', fontSize: '13px'}}>{aiJobData.yearsOfExperience} Years</span>
                                                            </div>
                                                        )}
                                                        {aiJobData.locationScope && (
                                                            <div className="col-12 mb-2">
                                                                <strong style={{color: '#555', fontSize: '13px'}}>Work Setting:</strong> <span style={{textTransform: 'capitalize', fontSize: '13px'}}>{aiJobData.locationScope}</span>
                                                            </div>
                                                        )}
                                                        {aiJobData.employmentType && (
                                                            <div className="col-12 mb-2">
                                                                <strong style={{color: '#555', fontSize: '13px'}}>Employment:</strong> <span style={{textTransform: 'capitalize', fontSize: '13px'}}>{aiJobData.employmentType}</span>
                                                            </div>
                                                        )}
                                                        {aiJobData.location_city && aiJobData.location_state && (
                                                            <div className="col-12 mb-2">
                                                                <strong style={{color: '#555', fontSize: '13px'}}>Location Match:</strong> <span style={{textTransform: 'capitalize', fontSize: '13px'}}>{aiJobData.location_city}, {aiJobData.location_state_abbr ? aiJobData.location_state_abbr.toUpperCase() : aiJobData.location_state}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        )}

                                        <div className="text-left mb-4 mt-2">
                                            <h4 className="text-uppercase"><small>JOB TYPE:</small></h4>
                                            <p>{jobDetails.strJobType}</p>
                                        </div>

                                        <div className="text-left mb-5">
                                            <h4 className="text-uppercase"><small>JOB SUMMARY</small></h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.summary }} />
                                            
                                            {/* --- DYNAMIC SKILLS (Mobile) --- */}
                                            {aiJobData && aiJobData.skills && aiJobData.skills.length > 0 && (
                                                <>
                                                    <p className="mt-4" style={{fontWeight: 'bold'}}>Key Skills</p>
                                                    <div className="skills mx-0 px-0">
                                                        {aiJobData.skills.map((skill, index) => (
                                                            <span key={index} className="skill" style={{textTransform: "capitalize", display: "inline-block", marginRight: "8px", marginBottom: "8px"}}>{skill}</span>
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="text-left mb-5">
                                            <h4 className="text-uppercase"><small>CAREER LEVEL: </small></h4>
                                            <p>{jobDetails.career}</p>
                                        </div>

                                        <div className="text-left mb-5">
                                            <h4 className="text-uppercase"><small>EXPERIENCE/CERTIFICATION REQUIRED:</small></h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.experiance }} />
                                        </div>

                                        <div className="text-left mb-5">
                                            <h4 className="text-uppercase"><small>SALARY/BENEFITS: </small></h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.salary }} />
                                        </div>

                                        <div className="text-left mb-5">
                                            <h4 className="text-uppercase"><small>ADDITIONAL INSTRUCTIONS TO APPLY: </small></h4>
                                            <p dangerouslySetInnerHTML={{ __html: jobDetails.apply }} />
                                            <div style={{ marginTop: "25px" }}>
                                                {(jobDetails.jobApplyUrl == '' || jobDetails.jobApplyUrl == null) ? <a href={"/applyJobProfile?jobId=" + jobDetails.jobId} className="reg-button">Apply Now</a> : <a href={jobDetails.jobApplyUrl} target="_blank" rel="noreferrer" className="reg-button">Apply Now</a>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-4">
                                <div className="p-4 white-bg mb-4">
                                    <div className="bg-heading">
                                        <h3 className="mb-0">job perks</h3>
                                    </div>
                                    <ul className="mt-4 job-perks">
                                        {perksListInfo.map((datap, index) => (
                                            <li key={index}> <span> <img src={datap.perksImageUrl} alt="" /></span> {datap.perksTitle}</li>
                                        ))}
                                    </ul>
                                    <hr className="mt-4 mb-4" />
                                    <div className="text-center mb-3">
                                        {(jobDetails.jobApplyUrl == '' || jobDetails.jobApplyUrl == null) ? <a href={"/applyJobProfile?jobId=" + jobDetails.jobId} className="reg-button">Apply Now</a> : <a href={jobDetails.jobApplyUrl} target="_blank" rel="noreferrer" className="reg-button">Apply Now</a>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <section className="white-bg py-5 p-4 cd-desktop">
                    <div className="container">
                        <div className="row mb-4 mt-4">
                            <Hiring />
                        </div>
                    </div>
                </section>
                
            </main>
        </>
    )
};

export default AIJobSummary;